const styles = (theme) => ({
    dialog: {
      width: "32%",
      maxWidth: 490,
      minHeight: 362,
      flex: 1,
      backgroundColor: theme.ModalBGColor,
    },
    dialogTitle: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: 0,
      borderBottom: `1px solid ${theme.scrollThumbColor}`,
    },
    stopTime: {
      padding: "4 20",
      color: theme.iconColor,
      textAlignLast: "right",
      fontWeight: 600,
      fontSize: theme.textFontSize,
      lineHeight: "16px",
    },
    dialogTitleText: {
      flexDirection: "column",
      fontSize: theme.headerTextFontSize,
      fontWeight: "600",
      lineHeight: "20px",
      color: theme.palette.primary.main,
      display: "flex",
    },
    dialogSubTitleText: {
      fontWeight: 400,
      fontSize: theme.textFontSize,
      lineHeight: "16px",
      color: theme.subHeaderTextColor,
    },
    dialogContent: {
      padding: "12 20 20 20",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column"
    },
    stopStatusContainer: {
      display: "flex",
      justifyContent: "space-between",
      backgroundColor: theme.trailerBackgroundColor,
      alignItems: "center",
    },
    statusPadding: {
      padding: "4 20",
    },
    addressPadding: {
      padding: "12 20",
    },
    stopStatusLabel: {
      fontWeight: 500,
      fontSize: theme.textFontSize,
      lineHeight: "19px",
      color: theme.iconColor,
      marginRight: 4,
    },
    stopStatusValue: {
      fontWeight: 600,
      fontSize: theme.textFontSize,
      lineHeight: "19px",
      color: theme.iconColor,
    },
  });

  export default styles;